<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('pages.districts.districtNameEn')">
              <b-form-input type="text" v-model="$v.createForm.nameEn.$model" :state="!$v.createForm.nameEn.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.nameEn.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.districts.districtNameRu')">
              <b-form-input type="text" v-model="$v.createForm.nameRu.$model" :state="!$v.createForm.nameRu.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.nameRu.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    createForm: {
      nameEn: '',
      nameRu: ''
    }
  }),
  validations: {
    createForm: {
      nameEn: { required },
      nameRu: { required }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.createForm.nameEn,
          name_ru: this.createForm.nameRu
        }

        this.$store.dispatch('districts/createDistrict', {
          payload,
          vm: this
        })
      }
    }
  }
}
</script>
